var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_38646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6378 9.29369C56.6966 1.70177 30.125 0.13875 12.0385 9.29369L11.3687 13.5362L28.562 31.6227H60.2692L67.6378 9.29369Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7372 57.0775C15.1383 55.1813 3.98575 37.8087 4.00001 32.069L12.0385 9.73999C14.2714 15.7688 25.9054 20.6641 38.1634 24.9237L18.7372 57.0775Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9386 57.0775C64.5375 55.1813 75.69 37.8087 75.6758 32.069L67.6373 9.73999C65.4044 15.7688 53.7703 20.6641 41.5123 24.9237L60.9386 57.0775Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7745 38.5448C41.7679 40.6261 37.3267 40.4393 29.4551 38.5448L37.9401 24.9241H41.5128L49.7745 38.5448Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8823 20.0118C36.6683 17.7209 42.9015 17.7844 54.2402 20.0118",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.7266,
    cy: 34.3022,
    r: 1.5,
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 1.46581
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_490_38646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0345,
    cy: 46.3012,
    rx: 2.67948,
    ry: 2.2329,
    transform: "rotate(21.7832 18.0345 46.3012)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0345,
    cy: 46.3012,
    rx: 2.67948,
    ry: 2.2329,
    transform: "rotate(21.7832 18.0345 46.3012)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7369 46.1823C17.8886 45.8027 18.1708 45.6531 18.2798 45.6177C18.381 45.5848 18.3885 45.6166 18.3192 45.5889L16.0926 51.1605C18.5082 52.1258 22.0546 51.5465 23.3085 48.4088L17.7369 46.1823ZM18.3192 45.5889C18.2499 45.5612 18.2773 45.5433 18.3279 45.6369C18.3824 45.7377 18.4839 46.0406 18.3322 46.4201L12.7606 44.1936C11.5067 47.3313 13.6771 50.1951 16.0926 51.1605L18.3192 45.5889ZM18.3322 46.4201C18.1805 46.7997 17.8983 46.9493 17.7892 46.9847C17.6881 47.0176 17.6805 46.9858 17.7499 47.0135L19.9764 41.442C17.5609 40.4766 14.0145 41.0559 12.7606 44.1936L18.3322 46.4201ZM17.7499 47.0135C17.8192 47.0412 17.7918 47.0591 17.7412 46.9655C17.6866 46.8647 17.5852 46.5619 17.7369 46.1823L23.3085 48.4088C24.5624 45.2711 22.392 42.4073 19.9764 41.442L17.7499 47.0135Z",
    fill: "#999999",
    mask: "url(#path-7-inside-1_490_38646)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_490_38646",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.3664,
    cy: 45.9962,
    rx: 2.2329,
    ry: 2.70388,
    transform: "rotate(15.7663 61.3664 45.9962)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.3664,
    cy: 45.9962,
    rx: 2.2329,
    ry: 2.70388,
    transform: "rotate(15.7663 61.3664 45.9962)",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6281 45.7878C60.6041 45.8731 60.5763 45.8557 60.6592 45.7983C60.7489 45.7363 61.0431 45.5972 61.4468 45.7112L59.8165 51.4855C63.0903 52.4098 65.6994 49.9081 66.4024 47.4181L60.6281 45.7878ZM61.4468 45.7112C61.8506 45.8252 62.0286 46.0976 62.0726 46.1973C62.1132 46.2896 62.0805 46.2899 62.1046 46.2046L56.3303 44.5744C55.6273 47.0644 56.5428 50.5612 59.8165 51.4855L61.4468 45.7112ZM62.1046 46.2046C62.1287 46.1194 62.1564 46.1368 62.0735 46.1941C61.9838 46.2562 61.6897 46.3952 61.2859 46.2812L62.9162 40.5069C59.6425 39.5826 57.0334 42.0843 56.3303 44.5744L62.1046 46.2046ZM61.2859 46.2812C60.8821 46.1672 60.7041 45.8949 60.6601 45.7951C60.6195 45.7028 60.6522 45.7025 60.6281 45.7878L66.4024 47.4181C67.1054 44.928 66.1899 41.4312 62.9162 40.5069L61.2859 46.2812Z",
    fill: "#999999",
    mask: "url(#path-9-inside-2_490_38646)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_38646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonDown);
export default __webpack_public_path__ + "static/media/button_down.e24cddf85f5a35ad76adaad4e271140d.svg";
export { ForwardRef as ReactComponent };